"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.CarouselAutoPlayButton = void 0;
var react_1 = __importStar(require("react"));
var useInterval_1 = __importDefault(require("../../helpers/hook/useInterval"));
var Button_1 = require("../Button");
var CarouselContext_1 = require("./CarouselContext");
var CarouselAutoPlayButton = function (_a) {
    var className = _a.className, _b = _a.duration, duration = _b === void 0 ? 5000 : _b, rest = __rest(_a, ["className", "duration"]);
    var _c = CarouselContext_1.useCarouselContext(), index = _c.index, next = _c.next;
    var _d = useInterval_1["default"](function () {
        next && next();
    }, duration), stop = _d.stop, start = _d.start, reset = _d.reset, isRunning = _d.isRunning;
    // reset timer when index has changed
    react_1.useEffect(function () {
        reset();
    }, [index, reset]);
    return (react_1["default"].createElement(Button_1.Button, __assign({ className: [
            'carousel_auto-play-button',
            isRunning && 'playing',
            className,
        ], "aria-hidden": true, onClick: function () {
            if (isRunning) {
                stop();
            }
            else {
                start();
            }
        } }, rest)));
};
exports.CarouselAutoPlayButton = CarouselAutoPlayButton;
//# sourceMappingURL=CarouselAutoPlayButton.js.map